import { Component, input, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  imports: [FontAwesomeModule, TranslocoModule],
})
export class DialogHeaderComponent {
  label = input<string>();
  withCloseBtn = input<boolean>(true);
  close = output<void>();

  faClose = faClose;
}
